import { Action, ThunkDispatch } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import type { RootState } from "./store";
import { State } from "history";

export const useAppDispatch: <
  AppDispatch extends ThunkDispatch<State, undefined, Action> = ThunkDispatch<
    State,
    undefined,
    Action
  >,
>() => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
